<template>
    <section v-if="initialized" class="box-typical box-typical-dashboard panel panel-default">
        <header class="box-typical-header panel-heading">
            <h3 class="panel-title">{{ label }}</h3>
        </header>

        <div class="box-typical-body panel-body">
            <div class="user-card-row user-card-header">
                <div class="tbl-cell">
                    Date & Time
                </div>
                <div class="tbl-cell cell-name">
                    Name & Email
                </div>
                <div class="tbl-cell">
                    Status
                </div>
            </div>
            <div v-if="_.isEmpty(itemData)" :class="['alert', 'alert-info', 'm-3']">
                {{ emptyText || 'No record' }}
            </div>
            <article v-else v-for="item in itemData" :key="item.id" class="comment-item">

                <div class="user-card-row">
                    <div class="tbl-row">
                        <div class="tbl-cell cell-date" v-html="item.datetime"></div>
                        <div class="tbl-cell cell-name">
                            <span class="user-card-row-name">
                                <a :href="item.link" v-html="item.title"></a><br>
                            </span>
                        </div>
                        <div class="tbl-cell" v-html="item.status" ></div>
                    </div>
                </div>
                <!-- <div class="comment-item-txt" v-html="item.content"></div>
                <div class="comment-item-meta"> -->
                    <!--Реализация кнопками-->
                    <!--<button type="button" class="star">-->
                    <!--<i class="font-icon font-icon-star"></i>-->
                    <!--</button>-->
                    <!--<button type="button">-->
                    <!--<i class="font-icon font-icon-re"></i>-->
                    <!--</button>-->
                <!-- </div> -->
            </article>
        </div><!--.box-typical-body-->
    </section>
</template>
<script>

let cache = {};

export default {
    data() {
        return {
            initialized: false,
            items: [],
        }
    },

    props: ['label', 'endpoint', 'filter', 'sort', 'fields', 'emptyText'],

    mounted() {
        const localData = cache;
        this.items = _.get(localData, 'items', []);

        if (!_.isEmpty(this.items)) {
            this.initialized = true;
        }

        const filter = _.toPairs(this.filter)
            .reduce((tmp, [key, value]) => [...tmp, `${key}:${value}`], [])
            .join(';')
        const sort = _.toPairs(this.sort)
            .reduce((tmp, [key, value]) => [...tmp, `${key}:${value}`], [])
            .join(';')

        this.helpers('api').getData(this.endpoint, { filter, sort })
            .then(res => {
                this.items = res.data;
                this.initialized = true;
            })
            .catch(() => this.initialized = false)
    },

    destroyed() {
        cache = { items: this.items }
    },

    computed: {
        cacheKey() {
            return this.label + '/' + this.endpoint;
        },

        itemData() {
            return _.chain(this.items)
                .map(item => {
                    return {
                        id: item.id, type: item.type,
                        ...this.formatItemData(item),
                    }
                })
                .value();
        }
    },

    methods: {
        formatItemData(item) {
            const data = _.chain(this.fields)
                .toPairs()
                .map(([key, handler]) => {
                    const value = _.isFunction(handler) ? handler(item, this.__, this._) : '';
                    return [key, value];
                })
                .fromPairs()
                .value();

            return data;
        }
    }
}
</script>



// WEBPACK FOOTER //
// seventytwo/72cms-ui/src/components/dashboard-elements/ContentListPanelComponent.vue